import React, { useContext } from "react";
import { Order } from "../../Components/Admin";
import * as Constants from "../../Constants";
import * as Context from "../../Contexts";
import * as WSConstants from "../../Constants/websocket";

const Orders = () => {
  const statuses = [
    Constants.ORDER_STATUSES.COMPLETED,
    Constants.ORDER_STATUSES.CANCELLED
  ];

  const {
    completed_orders
  } = useContext(Context.MerchantContext);

  return (
    <Order.Orders eventType={WSConstants.MESSAGE_TYPES.COMPLETED_ORDERS_LIST}
      statuses={statuses}
      pageTitle="Order History"
      orders={completed_orders} />
  )
};

export default Orders;
